module.exports = __webpack_public_path__ + "static/img/5-Draft.ed2706e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/5-Draft.jpg
// module id = EF0J
// module chunks = 0